import { Duration } from '@js-joda/core';

import { useTimeBasedAuthenticationCreationParametersQuery } from '@dreryk/egabinet-security-frontend';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../translations';

export type AuthenticationDetails = {
   windowLength: Duration;
   issuer: string;
   label: string;
   algorithm: string;
   secret: string;
};

type CreateAssociationPanelLoaderRenderProps = {
   authenticationDetails: AuthenticationDetails;
};

type CreateAssociationPanelLoaderProps = {
   readonly children: (renderProps: CreateAssociationPanelLoaderRenderProps) => JSX.Element;
};

export const CreateAssociationPanelLoader = (props: CreateAssociationPanelLoaderProps): JSX.Element => {
   const {
      data: timeBasedAuthenticationCreationParameters,
      loading: timeBasedAuthenticationCreationParametersLoading,
      error: timeBasedAuthenticationCreationParametersError,
   } = useTimeBasedAuthenticationCreationParametersQuery();

   if (timeBasedAuthenticationCreationParametersLoading) {
      return <LoaderSpinner />;
   }

   if (timeBasedAuthenticationCreationParametersError) {
      return (
         <Message
            testId={'failedToFetchMfaDetails'}
            label={mfaSettingsTranslationKeys.failedToFetchMfaInfo}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      authenticationDetails: timeBasedAuthenticationCreationParameters,
   });
};
